export const ON_SESSION_UPDATED = /* GraphQL */ `
  subscription OnSessionUpdated($sessionId: ID!) {
    onSessionUpdated(sessionId: $sessionId) {
      sessionId
      status
      currentStep
      lastUpdatedAt
      bookingState {
        searchParams {
          origin
          destination
          departureDate
          returnDate
          cabinClass
          passengerCount
        }
        selectedFlight {
          flightId
          flightNumber
          airline
          origin
          destination
          departureTime
          arrivalTime
          durationMinutes
          cabinClass
          price
          currency
        }
        selectedSeats
        passengers {
          passengerId
          firstName
          lastName
          dateOfBirth
          passportNumber
          nationality
        }
        payment {
          intentId
          status
          amountCents
          currency
        }
        confirmationCode
      }
      agentNotes
      agentOverride {
        targetStep
        prefillSeat
        message
      }
    }
  }
`;
